module.exports = __webpack_public_path__ + "img/account-choose-icon-dark.d2a2d21b.svg";